import { useState } from 'react';

import LocalText from '@/localization/local_text';
import { nicknameUpdate } from '@/network/apis/apiUri';
import { errorAlert, i10nAlert } from '@/util';
import settingImage from '@/assets/images/icon/setting.png';
import GoogleAuthn from './googleAuthn';

export function ModifyModal({ mode, handleClose }) {
  const userData = JSON.parse(localStorage.getItem('userData'));

  const handleLogOut = () => {
    localStorage.removeItem('userData');
    handleClose();
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData(e.currentTarget);

    const nick = formData.get('nickname');

    if (!nick) {
      i10nAlert('insert_nick_2');
      return;
    }

    nicknameUpdate({ nick_name: nick })
      .then((res) => {
        localStorage.setItem(
          'userData',
          JSON.stringify({
            token: res.data.resultCode.access_token.slice(7),
            nickName: res.data.nick_name,
          })
        );
        alert(mode === 'en' ? 'Change Success' : '정상적으로 변경되었습니다.');
        handleClose();
      })
      .catch(errorAlert);
  };

  return (
    <div className="authn-modal">
      <form className="authn-modal__wrapper" onSubmit={handleSubmit} onReset={handleClose}>
        <div className="modify__header">
          <h2 className="modify__title">
            <img className="modify__logo" src={settingImage} alt="icon"></img>
            {mode === 'en' ? 'Setting' : '설정'}
          </h2>
          <button type="button" className="button--logout" onClick={handleLogOut}>
            {mode === 'en' ? 'Logout' : '로그아웃'}
          </button>
        </div>
        <div className="modify__body">
          <div className="modify__item bg-skyblue">
            <p className="modify__item__title">{mode === 'en' ? 'Current Nickname' : '현재 닉네임'}</p>
            <p className="modify__item__nick">{userData.nickName ?? 'Unknown'}</p>
          </div>
          <div className="modify__item">
            <h2 className="modify__item__title">{mode === 'en' ? 'Change Nickname' : '닉네임 변경'}</h2>
            <input
              type="text"
              name="nickname"
              placeholder={mode === 'en' ? 'Enter the nickname you want to change.' : '변경할 닉네임을 입력하세요.'}
              className="modify__item__input"
            />
          </div>
        </div>
        <div className="modify__footer">
          <button type="reset" className="modify__footer__button button--cancel">
            {mode === 'en' ? 'Cancel' : '취소'}
          </button>
          <button type="submit" className="modify__footer__button button--modify">
            {mode === 'en' ? 'Modify' : '변경'}
          </button>
        </div>
      </form>
    </div>
  );
}

function LoginModal({ mode, handleClose }) {
  const [option, setOption] = useState({
    exist: 'no',
    nick: '',
  });

  const handleNickChange = (e) => {
    const { name, value } = e.currentTarget;

    setOption({ ...option, [name]: value });
  };

  const isFirst = option.exist === 'no';
  return (
    <div className="authn-modal">
      <div className="authn-modal__wrapper login">
        <div className="login__header">
          <h2 className="login__header__title">
            <LocalText txt={'radio_livechat_pop_title'} />
          </h2>
        </div>
        <div className="login__content">
          <p className="login__content__description">
            <LocalText txt={'radio_livechat_pop_sub'} />
          </p>
          <div className="login__content__box backC-grey">
            <button
              type="button"
              name="exist"
              value="yes"
              className={`login__content__button--radio ${!isFirst && 'on'}`}
              onClick={handleNickChange}
            >
              {mode === 'en' ? 'Yes' : '예'}
            </button>
            <button
              type="button"
              name="exist"
              value="no"
              className={`login__content__button--radio ${isFirst && 'on'} `}
              onClick={handleNickChange}
            >
              {mode === 'en' ? 'No' : '아니오'}
            </button>
          </div>
          {isFirst && (
            <div className="login__content__box">
              <label htmlFor="inputNick" className="login__content__text-label">
                <LocalText txt={'radio_livechat_pop_nickname'} />
              </label>
              <input
                type="text"
                id="inputNick"
                name="nick"
                className="login__content__text-input"
                onChange={handleNickChange}
              />
            </div>
          )}
          <div className="login__content__box">
            <GoogleAuthn option={option} handleClose={handleClose} />
          </div>
        </div>
        <div className="login__footer">
          <button type="button" className="login__footer__button button--reset" onClick={handleClose}>
            <LocalText txt={'radio_livechat_pop_cancel'} />
          </button>
        </div>
      </div>
    </div>
  );
}

export default function AuthnComponent(props) {
  const { mode, state, dispatch } = props;
  const handleClose = () => {
    dispatch('CLOSE');
  };

  switch (state) {
    case 'login':
      return <LoginModal mode={mode} handleClose={handleClose} />;
    case 'modify':
      return <ModifyModal mode={mode} handleClose={handleClose} />;
    default:
      return null;
  }
}
